import React from "react";
import intl from "react-intl-universal";

export interface CustomInterval {
    work: number;
    rest: number;
}

interface CustomIntervalInputProps {
    value: CustomInterval;
    onChange: (val: CustomInterval) => void;
}

export const CustomIntervalInput = ({value, onChange}: CustomIntervalInputProps) => {
    const handleChange = (key: keyof CustomInterval, newVal: string) => {
        const num = newVal === '' ? '' : parseInt(newVal);
        if (num === '' || (num >= 1 && num <= 99)) {
            onChange({...value, [key]: num});
        }
    };

    return (
        <div className="CustomIntervalInput__block">
            <input
                className="CustomIntervalInput__input body-large"
                value={value.work}
                onChange={(e) => handleChange('work', e.target.value)}
                placeholder="1"
                inputMode="numeric"
                type={'number'}
            />
            <span className="CustomIntervalInput__label">
                {intl.get("customInterval.between.on").d("on")}
            </span>
            <input
                className="CustomIntervalInput__input body-large"
                value={value.rest}
                onChange={(e) => handleChange('rest', e.target.value)}
                placeholder="2"
                inputMode="numeric"
                type={'number'}
            />
            <span className="CustomIntervalInput__label">
                {intl.get("customInterval.between.-off").d("– off")}
            </span>
        </div>
    );
};
